import React from 'react';
import { Typography } from '@mui/material';
import MLButton from '../Button/Button';
import MLCustomIcon from '../CustomIcon';

const NoDataFound = ({
  message = 'No data found !',
  includeBtn = false,
  btnText = 'Button',
  onBtnClick = () => {},
  classList = '',
  iconFill = 'var(--Orange-100)',
}) => {
  return (
    <div
      className={`w-full min-h-[300px]  flex items-center justify-center bg-[var(--Grey-10)] no-data-wrap ${classList}`}
    >
      <div className="flex flex-col items-center justify-center">
        <MLCustomIcon
          iconName="No-data-found"
          height="50"
          width="50"
          fill={iconFill}
        />
        <Typography variant="h5">{message}</Typography>
        {includeBtn && (
          <MLButton
            btnText={btnText}
            onClickFunc={onBtnClick}
            btnSize="medium"
          />
        )}
      </div>
    </div>
  );
};

export default NoDataFound;
